import Marquee from "react-fast-marquee";

const DEFAULT_PHRASES = [
  "quality banter",
  "cold beers",
  "new ideas",
  "aussie rap",
  "mma",
  "culture",
];

export default function KineticMarquee({
  phrases = DEFAULT_PHRASES,
  speed = 55,
  outline = true,
  className = "",
}) {
  return (
    <div
      data-testid="kinetic-marquee"
      className={`w-full overflow-hidden border-y-2 border-[var(--tsws-green)] bg-[var(--tsws-orange-light)] py-4 ${className}`}
    >
      <Marquee gradient={false} speed={speed} pauseOnHover={false} autoFill>
        {phrases.map((phrase, idx) => (
          <span
            key={idx}
            className={`marquee-text font-display ${
              outline && idx % 2 === 1
                ? "text-stroke"
                : "text-[var(--tsws-green)]"
            }`}
          >
            {phrase} <span className="text-[var(--tsws-cigar)]">✦</span>{" "}
          </span>
        ))}
      </Marquee>
    </div>
  );
}
